import Vue from 'vue';

export const fetchPaymentHistory = async ({ session }) => {
  const response = await Vue.axios.get(`/payments/list/${session}`);

  return response.data.payments;
};
